/**
 * ClientBudgetsStore
 * Extends the BaseStore for managing ClientBudgets.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { ClientBudgetInterface } from '@sah/Classes/ClientBudget';

class ClientBudgetsStore extends BaseStore<ClientBudgetInterface> {}

export default new ClientBudgetsStore();
